/**
 * @param {number} amount
 * @param {number} numberOfPayments
 * @param {number} rate
 * @param {number} loanRatio
 */
export function pmt(amount, numberOfPayments, rate, loanRatio) {
    var rateMonthly = rate / 12;
    var degree = numberOfPayments - loanRatio;
    return amount * ((rateMonthly * Math.pow(1 + rateMonthly, degree)) / (Math.pow(1 + rateMonthly, degree) - 1));
}
/**
 * @param {number} amount
 * @param {number} numberOfPayments
 * @param {number} rateSPPI
 */
export function calculateLoanAmount(amount, numberOfPayments, rateSPPI) {
    var result = amount + (amount * (numberOfPayments + 1) * rateSPPI) / (1 - (numberOfPayments + 1) * rateSPPI);
    return Math.ceil(result / 1000) * 1000;
}
/**
 * @param {number} amount
 * @param {number} numberOfPayments
 * @param {number} rateSPPI
 */
export function calculateInsuredAmount(amount, numberOfPayments, rateSPPI) {
    return amount * rateSPPI * (numberOfPayments + 1);
}
/**
 *
 * @param {number} debtEndOfMonth
 * @param {number} rate
 * @param {number} daysInYear
 * @param {number} daysInMonth
 */
export function calculateInterest(debtEndOfMonth, rate, daysInYear, daysInMonth) {
    return ((debtEndOfMonth * rate) / daysInYear) * daysInMonth;
}
